/* js/city-modal.js — Модалка выбора города (как у Самолёта).
 *
 * Plan site-changes-backlog блок 1.2+1.3.
 *
 * Поведение (всё через делегирование на document, БЕЗ inline-обработчиков — CSP):
 *   • клик по [data-city-modal-open] (кнопка .header-city) → открыть модалку
 *   • [data-city-modal-close] / клик по оверлею / Escape → закрыть
 *   • focus-trap внутри диалога + возврат фокуса на кнопку при закрытии
 *   • aria-expanded на кнопке-триггере
 *   • поиск: фильтр пунктов по data-city-search-key (lower-name)
 *   • клик по [data-city-pick]: записать cookie bd_city (180д, SameSite=Lax,
 *     Secure, Path=/) и НЕ preventDefault — <a href> сам ведёт на
 *     /novostroyki/{slug}/ (graceful, работает без JS / для ботов).
 *
 * ⛔ АНТИ-КЛОАКИНГ: cookie пишется ТОЛЬКО по явному клику пользователя.
 * Список городов = серверные <a href> (одинаковы для всех). AJAX-подстановка
 * контента на главной — отдельный подблок 1.5 (здесь НЕ делаем).
 *
 * ES5-совместимо (var/function), как js/app.js / js/shared.js.
 */
(function () {
  'use strict';

  var COOKIE_NAME = 'bd_city';
  var COOKIE_TTL_DAYS = 180;

  var overlay = document.getElementById('cityModalOverlay');
  if (!overlay) return;
  var dialog = document.getElementById('cityModal');
  if (!dialog) return;

  // Кнопка-триггер (последняя кликнутая) — для возврата фокуса при закрытии.
  var lastTrigger = null;

  /** Все элементы, на которые можно поставить фокус внутри диалога. */
  function focusableEls() {
    var sel = 'a[href], button:not([disabled]), input:not([disabled]), [tabindex]:not([tabindex="-1"])';
    var nodes = dialog.querySelectorAll(sel);
    var out = [];
    for (var i = 0; i < nodes.length; i++) {
      // offsetParent === null → скрытый (display:none) → пропускаем.
      if (nodes[i].offsetParent !== null || nodes[i] === document.activeElement) {
        out.push(nodes[i]);
      }
    }
    return out;
  }

  function isOpen() {
    return !overlay.hasAttribute('hidden');
  }

  function openModal(trigger) {
    if (isOpen()) return;
    lastTrigger = trigger || null;
    overlay.removeAttribute('hidden');
    overlay.classList.add('is-open');
    document.body.style.overflow = 'hidden';
    if (lastTrigger && lastTrigger.setAttribute) {
      lastTrigger.setAttribute('aria-expanded', 'true');
    }
    // Фокус в поле поиска (если есть), иначе на первый focusable.
    var search = dialog.querySelector('[data-city-search]');
    if (search) {
      search.focus();
    } else {
      var els = focusableEls();
      if (els.length) els[0].focus();
    }
  }

  function closeModal() {
    if (!isOpen()) return;
    overlay.setAttribute('hidden', '');
    overlay.classList.remove('is-open');
    document.body.style.overflow = '';
    if (lastTrigger && lastTrigger.setAttribute) {
      lastTrigger.setAttribute('aria-expanded', 'false');
      if (lastTrigger.focus) lastTrigger.focus();
    }
    lastTrigger = null;
  }

  /** Запись cookie bd_city по выбору города. */
  function setCityCookie(slug) {
    if (!slug || !/^[a-z]{2,15}$/.test(slug)) return;
    var d = new Date();
    d.setTime(d.getTime() + COOKIE_TTL_DAYS * 24 * 60 * 60 * 1000);
    var secure = (location.protocol === 'https:') ? '; Secure' : '';
    document.cookie = COOKIE_NAME + '=' + slug +
      '; expires=' + d.toUTCString() +
      '; path=/; SameSite=Lax' + secure;
  }

  /** Фильтр списка городов по введённой строке (по data-city-search-key). */
  function filterCities(query) {
    var q = (query || '').toLowerCase().trim();
    var items = dialog.querySelectorAll('[data-city-pick]');
    var visibleCount = 0;
    for (var i = 0; i < items.length; i++) {
      var key = items[i].getAttribute('data-city-search-key') || '';
      var match = (q === '' || key.indexOf(q) !== -1);
      if (match) {
        items[i].removeAttribute('hidden');
        visibleCount++;
      } else {
        items[i].setAttribute('hidden', '');
      }
    }
    // Скрываем заголовки групп, где ничего не осталось.
    var groups = dialog.querySelectorAll('[data-city-group]');
    for (var g = 0; g < groups.length; g++) {
      var anyVisible = groups[g].querySelectorAll('[data-city-pick]:not([hidden])').length > 0;
      if (anyVisible) {
        groups[g].removeAttribute('hidden');
      } else {
        groups[g].setAttribute('hidden', '');
      }
    }
    // «Город не найден». Сервер отдаёт узел ПУСТЫМ (иначе Яндекс берёт надпись
    // в сниппет) — текст ставим только в момент показа и снимаем при скрытии.
    var empty = dialog.querySelector('[data-city-modal-empty]');
    if (empty) {
      if (visibleCount === 0) {
        empty.textContent = 'Город не найден';
        empty.removeAttribute('hidden');
      } else {
        empty.setAttribute('hidden', '');
        empty.textContent = '';
      }
    }
    return visibleCount;
  }

  // ── Делегирование кликов на document (CSP: addEventListener) ──────
  document.addEventListener('click', function (e) {
    var t = e.target;
    if (!t || !t.closest) return;

    var openBtn = t.closest('[data-city-modal-open]');
    if (openBtn) {
      e.preventDefault();
      openModal(openBtn);
      return;
    }

    if (t.closest('[data-city-modal-close]')) {
      e.preventDefault();
      closeModal();
      return;
    }

    // Клик по самому оверлею (фон), но не по диалогу внутри.
    if (t === overlay) {
      closeModal();
      return;
    }

    // Клик по городу: пишем cookie, НЕ preventDefault — <a href> навигирует.
    var pick = t.closest('[data-city-pick]');
    if (pick) {
      setCityCookie(pick.getAttribute('data-city-pick'));
      // навигация по href происходит штатно (graceful).
    }
  });

  // ── Escape + focus-trap (Tab) ─────────────────────────────────────
  document.addEventListener('keydown', function (e) {
    if (!isOpen()) return;
    if (e.key === 'Escape' || e.keyCode === 27) {
      e.preventDefault();
      closeModal();
      return;
    }
    if (e.key === 'Tab' || e.keyCode === 9) {
      var els = focusableEls();
      if (!els.length) return;
      var first = els[0];
      var last = els[els.length - 1];
      if (e.shiftKey && document.activeElement === first) {
        e.preventDefault();
        last.focus();
      } else if (!e.shiftKey && document.activeElement === last) {
        e.preventDefault();
        first.focus();
      }
    }
  });

  // ── Поиск по вводу ────────────────────────────────────────────────
  var searchInput = dialog.querySelector('[data-city-search]');
  if (searchInput) {
    searchInput.addEventListener('input', function () {
      filterCities(searchInput.value);
    });
  }

  // Экспорт для тестов / прочих скриптов.
  window.cityModal = {
    open: openModal,
    close: closeModal,
    isOpen: isOpen,
    filter: filterCities,
    setCookie: setCityCookie
  };
})();
